'use strict';

/* global Raven */

/** @todo This should be an npm module */
require('../../../collected_static/bower_components/gettext/gettext');
var bluebird = require('bluebird');
window.fetch = undefined;
require('whatwg-fetch');

require('./helpers/yohandlebars');
var clickTracking = require('./tracking/click-tracking');
var contentAnimation = require('./content-animation');
var imageLoader = require('./image-loader');
var mobileNav = require('./mobile-nav');
var modals = require('./ui/modals');
var trackingFunctions = require('./tracking/tracking_functions');
var cookiesNotification = require('./ui/cookies-notification');
var injectSolidarityBanner = require('./ui/solidarity-banner');
var injectDiscountBanner = require('./ui/discount-banner');
var getDiscountInfo = require('./helpers/get-discount-info');

require('./language-selector')();

cookiesNotification();

window.Promise = bluebird;

trackingFunctions.trackPage()
  .catch(Raven.captureException);
clickTracking.init()
  .catch(Raven.captureException);
contentAnimation.init()
  .catch(Raven.captureException);
mobileNav.init()
  .catch(Raven.captureException);
imageLoader.init()
  .catch(Raven.captureException);
modals.init();

var initializeBanner = function () {
  getDiscountInfo()
    .then(function (discountInfo) {
      if (discountInfo.duration <= 0 || !discountInfo.value) {
        injectSolidarityBanner(document.body);
      } else {
        injectDiscountBanner(document.body, {
          discountValue: discountInfo.value,
          discountDuration: discountInfo.duration
        });
      }
    });
}

initializeBanner();
